import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import AppSidebar from "../AppSidebar/AppSidebar";
import LoadingScreen from "../../utils/LoadingScreen";

const AuthenticatedLayout = () => {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-gray-50">
      <AppSidebar />
      <main className="flex-1 overflow-auto">
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
};

export default AuthenticatedLayout;
